/**
 * Fancybox lightbox for [data-fancybox] (videos, galleries).
 * Fancybox CSS is part of theme.css.
 */
import { Fancybox } from '@fancyapps/ui';

Fancybox.bind( '[data-fancybox]' );
